import { render, staticRenderFns } from "./FieldTypeChoice.vue?vue&type=template&id=9bac859e&"
import script from "./FieldTypeChoice.vue?vue&type=script&lang=ts&"
export * from "./FieldTypeChoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports